import FuseNavigation from '@fuse/core/FuseNavigation';
import { twMerge } from 'tailwind-merge';
import { useMemo } from 'react';
import { useAppDispatch } from 'src/store/hooks';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { FuseNavigationProps } from '@fuse/core/FuseNavigation/FuseNavigation';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';
import { openDialog } from '@fuse/core/FuseDialog/fuseDialogSlice';
import { navbarCloseMobile } from '../navbar/navbarSlice';
import useNavigation from './hooks/useNavigation';
import { SupportRequestModal } from '@/components/modals';

/**
 * Navigation
 */

type NavigationProps = Partial<FuseNavigationProps>;

function Navigation(props: NavigationProps) {
	const { className = '', layout = 'vertical', dense, active } = props;
	const { navigation } = useNavigation();

	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

	const dispatch = useAppDispatch();

	return useMemo(() => {
		function handleItemClick(item: FuseNavItemType) {
			// Handle support request modal
			if (item.id === 'support-tickets') {
				dispatch(openDialog({
					children: <SupportRequestModal />,
					options: {
						maxWidth: 'sm',
						fullWidth: true
					}
				}));

				if (isMobile) {
					dispatch(navbarCloseMobile());
				}
				return;
			}

			if (isMobile) {
				dispatch(navbarCloseMobile());
			}
		}

		return (
			<FuseNavigation
				className={twMerge('navigation flex-1', className)}
				navigation={navigation}
				layout={layout}
				dense={dense}
				active={active}
				onItemClick={handleItemClick}
				checkPermission
			/>
		);
	}, [dispatch, isMobile, navigation, active, className, dense, layout]);
}

export default Navigation;
